module.exports = __webpack_public_path__ + "img/thumb_10.45d649a3.jpg";